import * as Forms       from '../../components/forms';
import Link             from '../../components/link';
import PrimaryButton    from '../../components/primary_button';
import React            from 'react';
import StandaloneButton from '../../components/standalone_button';


export function Form({ onSubmit, onLoginClick }) {
  return (
    <React.Fragment>
      <div className="block inset">
        <h3>Password Help</h3>
        <p>
          Having trouble signing in? Enter your account email address and then click Continue. We&#x27;ll send you an email with a link to a page where you can easily create a new password.
        </p>
      </div>
      <Forms.Form save={onSubmit}>
        <Fields/>
      </Forms.Form>
      <StandaloneButton label="Back to sign-in" onClick={onLoginClick}/>
    </React.Fragment>
  );
}

function Fields(form) {
  return (
    <div className="list block inset">
      <ul>
        <Forms.Error  {...form}/>
        <Forms.Input  {...form} label="Email" name="email" type="email" autoFocus required/>
        <Forms.Button {...form} label="Continue"/>
      </ul>
    </div>
  );
}


export function ThankYou({ email, onLoginClick }) {
  return (
    <div className="block inset">
      <h3>Thank You!</h3>
      <p>You entered <strong>{email}</strong>. If this is the correct email address, we will send you an email to change your password.</p>
      <PrimaryButton label="Back To Sign In" onClick={onLoginClick}/>
      <p>If you don&#x27;t see an email in your inbox, you may want to try the following:</p>
      <ul>
        <li>Check your spam folder for the message.</li>
        <li>Check that you have provided the email address that&#x27;s associated with your Broadly account.</li>
        <li>Wait a bit longer for the email to arrive.</li>
        <li>Contact Broadly&#x27;s Customer Success team for further assistance.</li>
      </ul>
      <Link href="tel:1-800-727-0445" target="_self" className="call-customer-success__link" external>
        1-800-727-0445<br/>
        Broadly Customer Support
      </Link>
    </div>
  );
}

